/**
 * Derives forceHide for campLocations and campLocationVersions.data from workflowStatus.
 *
 * - wf_external* → not hidden (false)
 * - wf_archived*, wf_internal*, wf_new*, wf_unknown* → hidden (true)
 * - empty / other ids → false
 */
export function shouldForceHideFromWorkflowStatus(workflowStatus?: string | null): boolean {
  if (workflowStatus == null || workflowStatus === "") return false;
  const s = String(workflowStatus);
  if (s.startsWith("wf_external")) return false;
  return (
    s.startsWith("wf_archived") ||
    s.startsWith("wf_internal") ||
    s.startsWith("wf_new") ||
    s.startsWith("wf_unknown")
  );
}

/** True when a workflow transition would change derived forceHide (e.g. internal↔external). */
export function didForceHideChangeForWorkflowTransition(
  oldWorkflowStatus?: string | null,
  newWorkflowStatus?: string | null
): boolean {
  return (
    shouldForceHideFromWorkflowStatus(oldWorkflowStatus) !==
    shouldForceHideFromWorkflowStatus(newWorkflowStatus)
  );
}
